import AnxietySelfTest from './AnxietySelfTest';

export default AnxietySelfTest;
